
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    ORTSHORTGAME_ACTION,
    ALL_ORTSHORTGAME,
    ADD_ORTSHORTGAME,
    FETCH_ORTSHORTGAME,
    EDIT_ORTSHORTGAME,
    DELETE_ORTSHORTGAME,
    FETCH_ORTSHORTGAMECHART,
    FETCH_ORTSHORTGAMESHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Range Short Game Test Actions
 */

    export const allORTShortGame = () =>{    
        
        return (dispatch) => { 
            dispatch({ type: ORTSHORTGAME_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getonrshortgame', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTSHORTGAME, payload: alldata });
            });
        }        

    }

    export const studentORTShortGame = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:ORTSHORTGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentonrshortgame', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTSHORTGAME, payload: alldata }); 
            });
        
        }
    }

    export const addORTShortGame = (data, sepmore) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            var shot='shot_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;
            var putt='putt_'+i;            
            var puttval=data.target[putt].value;           
            
            var adval=i+1;
            var shotadd='shot_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            var puttadd='putt_1_'+adval;
            
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;
            payload[puttadd]=puttval;            
    
        }        

        return (dispatch) => { 
            dispatch({ type:ORTSHORTGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addonrshortgame', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTShortGame(stdid, start, end)(dispatch);
                    var shot='';
                    var area='';
                    var contact='';
                    fetchORTShortGameReport(stdid, start, end, shot, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_ORTSHORTGAME});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchORTShortGame = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:ORTSHORTGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getonrshortgamedetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_ORTSHORTGAME, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editORTShortGame = (data, sepmore, oldate) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            var shot='shot_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;
            var putt='putt_'+i;            
            var puttval=data.target[putt].value;           
            
            var adval=i+1;
            var shotadd='shot_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            var puttadd='putt_1_'+adval;
            
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;
            payload[puttadd]=puttval;            
    
        }  

        return (dispatch) => { 
            dispatch({ type:ORTSHORTGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editonrshortgame', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTShortGame(stdid, start, end)(dispatch);
                    var shot='';
                    var area='';
                    var contact='';
                    fetchORTShortGameReport(stdid, start, end, shot, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_ORTSHORTGAME});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteORTShortGame = (id, date) =>{
        
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTSHORTGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteonrshortgame', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTShortGame(id, start, end)(dispatch);
                    var shot='';
                    var area='';
                    var contact='';
                    fetchORTShortGameReport(id, start, end, shot, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_ORTSHORTGAME});                    
                }                
                
            });
        
        }
    }

    export const fetchORTShortGameReport = (id, start, end, shot, area, contact) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "shot":shot,
            "area":area,         
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTSHORTGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangeshortgamereport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTSHORTGAMECHART, payload: resdata}); 
                
                return Promise.resolve(resdata);               
                
            });
        
        }
    }

    export const fetchORTShortGameShotChart = (id, start, end, shot, area, contact, val) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "shot":shot,
            "area":area,
            "section":val            
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTSHORTGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangeshortgameshotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTSHORTGAMESHOTCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);               
                
            });
        
        }
    }

